// const FILE_BASE_URL = "http://localhost:5000/files/";

const FILE_BASE_URL = "https://bulkairtime.omnicontact.biz/files/";


export default FILE_BASE_URL